module.exports = __webpack_public_path__ + "files/c85f041b3951fb889af65c628f5e94a9.png";